import { useState, useEffect } from 'react';

export const renderToastTable = (toastContent) => {
	return (
		<>
			{toastContent?.map((item, index) => (
				<tr key={index}>
					<td
						style={{
							textAlign: 'top',
							paddingRight: '10px',
							width: '15%'
						}}
					>
						{item[0]}
					</td>
					<td
						title={
							typeof item[1] === 'object' &&
							Array.isArray(item[1]?.props?.children) &&
							item[1].props.children[0] === 'Execution ID:' &&
							`Execution ID: ${item[1].props.children[2].toString()}`
						}
						style={{ textAlign: 'top', paddingLeft: '10px' }}
					>
						{typeof item[1] === 'object' &&
						Array.isArray(item[1]?.props?.children) &&
						item[1].props.children[0] === 'Execution ID:'
							? `Execution ID: ${item[1].props.children[2]
									.toString()
									.slice(0, 35)}...`
							: item[1]}
					</td>
				</tr>
			))}
		</>
	);
};

export const toastContentDiv = (
	toastContent,
	{
		copyPostQCLogToClipboard,
		toggleToast,
		indexCalcStatusRef,
		fetchWSDataStatusRef,
		uploadStatusRef,
		websocketStatusRef,
		setIsToastVisible
	}
) => {
	return (
		<div style={{ width: '100%' }}>
			<div className="row pb-2">
				<div className="col-10 d-flex justify-content-center">
					<h5>Post QC Log Details</h5>
				</div>
				<div className="col-1 d-flex justify-content-center">
					<i
						onClick={() => copyPostQCLogToClipboard(toastContent)}
						title="Copy log details to clipboard"
						className="fa-regular fa-copy"
					></i>
				</div>
				<div className="col-1 d-flex justify-content-center">
					<i
						onClick={() => toggleToast(setIsToastVisible)}
						title="Close log"
						className="fa-solid fa-xmark"
					></i>
				</div>
			</div>

			<div className="row pb-3 d-flex justify-content-center">
				<div className="col d-flex justify-content-center align-items-center">
					Index calc <StatusIcon status={indexCalcStatusRef.current} />
				</div>
				<div className="col d-flex justify-content-center align-items-center">
					Post QC Data <StatusIcon status={fetchWSDataStatusRef.current} />
				</div>
				<div className="col d-flex justify-content-center align-items-center">
					Upload <StatusIcon status={uploadStatusRef.current} />
				</div>
				<div className="col d-flex justify-content-center align-items-center">
					WS <i className="ps-2 fa-solid fa-plug"></i>{' '}
					{websocketStatusRef.current === 1 ? (
						<i title="Websocket open" className="ps-2 fa-solid fa-spinner"></i>
					) : (
						<i
							title="Websocket closed"
							className="ps-2 fa-solid fa-circle-minus"
						></i>
					)}
				</div>
			</div>

			<div
				className="table"
				style={{ maxHeight: '250px', overflowY: 'scroll' }}
			>
				<table className="uploadToastNotificationsTable">
					<tbody>{renderToastTable(toastContent)}</tbody>
				</table>
			</div>
		</div>
	);
};

const formatElapsedTime = (totalSeconds) => {
	const minutes = Math.floor(totalSeconds / 60);
	const seconds = totalSeconds % 60;

	return `${minutes}:${String(seconds).padStart(2, '0')}`;
};

export const ProcessTimerToast = ({
	startedAtRef,
	finishedAtRef,
	processStateRef,
	runningMessage,
	completedMessage,
	errorMessage
}) => {
	const [elapsedSeconds, setElapsedSeconds] = useState(0);

	const status = processStateRef.current;
	const hasFinished = finishedAtRef.current !== null;

	useEffect(() => {
		const updateElapsedTime = () => {
			if (!startedAtRef.current) return;

			const endTime = finishedAtRef.current ?? Date.now();

			setElapsedSeconds(Math.floor((endTime - startedAtRef.current) / 1000));
		};

		updateElapsedTime();

		const intervalId = window.setInterval(updateElapsedTime, 1000);

		return () => window.clearInterval(intervalId);
	}, [startedAtRef, finishedAtRef]);

	if (hasFinished && status === 'error') {
		return (
			<span className="text-danger">
				<i className="fa-solid fa-triangle-exclamation me-2" />
				{errorMessage} after {formatElapsedTime(elapsedSeconds)}
			</span>
		);
	}

	if (hasFinished) {
		return (
			<span className="text-success">
				<i className="fa-solid fa-circle-check me-2" />
				{completedMessage} in {formatElapsedTime(elapsedSeconds)}
			</span>
		);
	}

	return (
		<span className="d-inline-flex align-items-center gap-2">
			<span
				className="spinner-border spinner-border-sm"
				role="status"
				aria-label="Processing"
			/>
			{runningMessage}… {formatElapsedTime(elapsedSeconds)}
		</span>
	);
};

export const toggleToast = (setIsToastVisible) => {
	setIsToastVisible((prev) => !prev);
};

const statusIcons = {
	0: <i className="ps-2 fa-regular fa-circle" title="Not started"></i>,
	// 1: <i className="ps-2 fa-solid fa-spinner" title="Loading ..."></i>, <div className="spinner-border spinner-border-sm" role="status" />
	1: <div className="spinner-border spinner-border-sm" role="status" />,
	2: <i className="ps-2 fa-regular fa-circle-check" title="Completed"></i>,
	3: (
		<i
			className="ps-2 fa-solid fa-circle-exclamation"
			title="Error in process"
		></i>
	),
	default: <i className="ps-2 fa-regular fa-circle-question"></i>
};

const StatusIcon = ({ status }) => statusIcons[status] || statusIcons.default;
